import { useDynamicSectionContext } from "../contexts/dynamicSectionContext";
import DynamicSection from "../dynamicSection";
import { Props } from "./types";

export default function DynamicComponentContainer(props: Props) {
	const { children, ...rest } = props;
	const { visibleSections } = useDynamicSectionContext();
	if (!visibleSections) return null;
	return (
		<>
			<section id="dynamicComponents">
				{visibleSections.map((s, i) => (
					<DynamicSection {...rest} section={s} key={i} />
				))}
			</section>
			{children}
		</>
	);
}
